export const transferSourceSystem = {
	Intranet: "intranet",
	ReceivingApp: "receivingapp",
	Algo: "algo",
	ReturnApp: "returnapp",
	TransferToCollect: "transfertocollect",
	TransactionApi: "transactionapi",
	ReplenishmentApi: "replenishmentapi",
};
